import PropTypes from 'prop-types';

const PeopleSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 40}`}
      height={`${height || 40}`}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M29.2167 12.95C29.1001 12.9334 28.9834 12.9334 28.8667 12.95C26.2834 12.8667 24.2334 10.75 24.2334 8.15004C24.2334 5.50004 26.3834 3.33337 29.0501 3.33337C31.7001 3.33337 33.8667 5.48337 33.8667 8.15004C33.8501 10.75 31.8001 12.8667 29.2167 12.95Z"
        fill={color}
      />
      <path
        opacity="0.4"
        d="M34.6503 24.5C32.7837 25.75 30.167 26.2167 27.7503 25.9C28.3837 24.5334 28.717 23.0167 28.7337 21.4167C28.7337 19.7501 28.367 18.1667 27.667 16.7834C30.1337 16.4501 32.7503 16.9167 34.6337 18.1667C37.267 19.9 37.267 22.75 34.6503 24.5Z"
        fill={color}
      />
      <path
        opacity="0.4"
        d="M10.733 12.95C10.8497 12.9334 10.9663 12.9334 11.083 12.95C13.6663 12.8667 15.7163 10.75 15.7163 8.15004C15.7163 5.50004 13.5663 3.33337 10.8997 3.33337C8.24967 3.33337 6.08301 5.48337 6.08301 8.15004C6.09967 10.75 8.14967 12.8667 10.733 12.95Z"
        fill={color}
      />
      <path
        opacity="0.4"
        d="M10.9169 21.4167C10.9169 23.0333 11.2669 24.5667 11.9002 25.95C9.55019 26.2 7.1002 25.7 5.3002 24.5167C2.66686 22.7667 2.66686 19.9167 5.3002 18.1667C7.08353 16.9667 9.6002 16.4833 11.9669 16.75C11.2835 18.15 10.9169 19.7334 10.9169 21.4167Z"
        fill={color}
      />
      <path
        d="M20.2 26.45C20.0667 26.4333 19.9167 26.4333 19.7667 26.45C16.7 26.35 14.25 23.8333 14.25 20.7333C14.25 17.5667 16.8 15 19.9833 15C23.15 15 25.7167 17.5667 25.7167 20.7333C25.7167 23.8333 23.2833 26.35 20.2 26.45Z"
        fill={color}
      />
      <path
        d="M14.783 29.9C12.2663 31.5834 12.2663 34.35 14.783 36.0167C17.6497 37.9334 22.3497 37.9334 25.2163 36.0167C27.733 34.3334 27.733 31.5667 25.2163 29.9C22.3663 27.9834 17.6663 27.9834 14.783 29.9Z"
        fill={color}
      />
    </svg>
  );
};

PeopleSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default PeopleSvg;
